import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import nexus1 from '../../assets/img-nexus-1.png';
import nexus2 from '../../assets/img-nexus-2.png';
import nexus3 from '../../assets/img-nexus-3.png';
import nexus4 from '../../assets/img-nexus-4.png';
import nexus5 from '../../assets/img-nexus-5.png';
import nexus6 from '../../assets/img-nexus-6.png';
import { useTranslation } from "react-i18next";

export const NexusUi = () =>{
    const { t } = useTranslation()
    return(
        <>
        <Container className="projectBody ">
        <Row xs='1' >
            <Col className="projectInfo" lg='5' >
            <h3>NEXUS UI</h3>
            <p className="roleText">
            {t("uxui_design")} &nbsp; &bull; &nbsp; {t("design_system")} &nbsp; &bull; &nbsp; {t("research")}
            </p>
            <p className="parragraph">
            {t("nexus_1parragraph")}
             <br/><br/>
             {t("nexus_2parragraph")}
             <br/><br/>
             {t("nexus_3parragraph")}
             <br/><br/>
             {t("nexus_4parragraph")}
             <br/><br/>
             {t("nexus_5parragraph")}
            </p>
            

            </Col>
            <Col className="projectDetails" lg='7'>
            <img src={nexus1} style={{width:'100%'}} alt="Early keypad and map screen, first iteration"></img>
            <img src={nexus2} style={{width:'100%'}} alt=""></img>
            <img src={nexus3} style={{width:'100%'}} alt="Map screen, mid iteration"></img>
            <img src={nexus4} style={{width:'100%'}} alt="Final dashboard with driving mode selector and energy flow"></img>
            <img src={nexus5} style={{width:'100%'}} alt="Battery and hybrid system details screen"></img>
            <img src={nexus6} style={{width:'100%'}} alt="Presenting Nexus UI at the SEMA Show Las Vegas 2025"></img>
            </Col>
        </Row>
        </Container>
        </>
    )
}

export default NexusUi;
